'use strict';

angular.module('inara') // need to put module *definition* before require statements
.config(Router);

require('./AudioBarController');
require('./AudioSourceController');
require('./CalendarController');
require('./CameraController');
require('./CallCardController');
require('./CallParticipantsController');
require('./CallDialPadController');
require('./CallsController');
require('./ContactUtilityService');
require('./ControlController');
require('./DeveloperInfoController');
require('./DialPadController');
require('./DirectoryController');
require('./DisplayController');
require('./FactoryInstallController');
require('./InfoController');
require('./LightingController');
require('./NavBarController');
require('./RecentsController');
require('./RemoteControlCodeController');
require('./RemoteControlSessionsController');
require('./RoomPasswordController');
require('./SetupController');
require('./SetupLanguageController');
require('./SetupNetworkController');
require('./SetupPairingController');
require('./SetupSummaryController');
require('./SetupWifiController');
require('./SideBarController');
require('./StartController');
require('./SystemInfoController');
require('./ThemeController');
require('./UpdateController');
require('./WallpaperController');

Router.$inject = ['$stateProvider', '$urlRouterProvider'];

function Router($stateProvider, $urlRouterProvider) {
    $stateProvider
    // Initial state for the app - bootstraps either setup or control states
    .state('start', {
        url: '/start?database&roomId&preview&language',
        templateUrl: 'start.html',
        controller: 'StartController as vm'
    })
    .state('factoryInstall', {
        url: '/factoryInstall',
        templateUrl: 'factoryInstall.html',
        controller: 'FactoryInstallController as vm'
    })
    .state('setup', {
        url: '/setup',
        templateUrl: 'setup.html',
        controller: 'SetupController as vm',
        abstract: true
    })
    .state('setup.start', {
        url: '/start',
        templateUrl: 'setupStart.html'
    })
    .state('setup.language', {
        url: '/language',
        templateUrl: 'setupLanguage.html',
        controller: 'SetupLanguageController as vm'
    })
    .state('setup.network', {
        url: '/network',
        templateUrl: 'setupNetwork.html',
        controller: 'SetupNetworkController as vm'
    })
    .state('setup.wifi', {
        url: '/wifi',
        templateUrl: 'setupWifi.html',
        controller: 'SetupWifiController as vm'
    })
    .state('setup.pairing', {
        url: '/pairing',
        templateUrl: 'setupPairing.html',
        controller: 'SetupPairingController as vm'
    })
    .state('setup.summary', {
        url: '/summary',
        templateUrl: 'setupSummary.html',
        controller: 'SetupSummaryController as vm'
    })
    .state('control', {
        url: '/control',
        templateUrl: 'control.html',
        controller: 'ControlController as control',
        abstract: true
    })
    .state('control.audiosource', {
        url: '/audiosource',
        templateUrl: 'audioSource.html',
        controller: 'AudioSourceController as vm'
    })
    .state('control.calls', {
        url: '/calls',
        templateUrl: 'calls.html',
        controller: 'CallsController as vm'
    })
    .state('control.call-dialpad', {
        url: '/calls/:call?calendarEventId',
        templateUrl: 'callDialPad.html',
        controller: 'CallDialPadController as vm'
    })
    .state('control.dialpad', {
        url: '/dialpad?calendarEventId',
        templateUrl: 'dialPad.html',
        controller: 'DialPadController as dialPad'
    })
    .state('control.directory', {
        url: '/directory',
        templateUrl: 'directory.html',
        controller: 'DirectoryController as vm'
    })
    .state('control.lighting', {
        url: '/lighting',
        templateUrl: 'lighting.html',
        controller: 'LightingController as vm'
    })
    .state('control.recents', {
        url: '/recents',
        templateUrl: 'recents.html',
        controller: 'RecentsController as recents'
    })
    .state('control.calendar', {
        url: '/calendar?calendarEventId',
        templateUrl: 'calendar.html',
        controller: 'CalendarController as calendar'
    })
    .state('control.camera', {
        url: '/camera',
        templateUrl: 'camera.html',
        controller: 'CameraController as vm'
    })
    .state('control.display', {
        url: '/display',
        templateUrl: 'display.html',
        controller: 'DisplayController as vm'
    })
    .state('control.remote', {
        url: '/remote',
        templateUrl: 'remote.html'
    })
    .state('control.noview', {
        url: '/noview',
        templateUrl: 'noView.html'
    })
    .state('info', {
        url: '/info',
        templateUrl: 'info.html',
        controller: 'InfoController as vm',
        abstract: true
    })
    .state('info.system', {
        url: '/system',
        templateUrl: 'systemInfo.html',
        controller: 'SystemInfoController as vm'
    })
    .state('info.developer', {
        url: '/developer',
        templateUrl: 'developerInfo.html',
        controller: 'DeveloperInfoController as vm'
    })
    .state('roomPassword', {
        url: '/roompassword',
        templateUrl: 'roomPassword.html',
        controller: 'RoomPasswordController as vm'
    })
    .state('update', {
        url: '/update',
        templateUrl: 'update.html',
        controller: 'UpdateController as vm'            
    });

    // If no matching state requested, default to the initial state
    $urlRouterProvider.otherwise('/start');
}

module.exports = Router;
